import dynamic from "next/dynamic"
import React from "react"
import classNames from 'classnames'
import { useLayout, useTranslations } from "@dustin-web/microsite-components/src/hooks"
import type { SliderType } from "@dustin-web/microsite-components/src/carousel-test/settings"
import { ListingType, type LandingPageGroupList } from "../data/types"
import { getDigitalDataOrigin } from "../utils/digital-data"
import { getColorThemeClass } from "../utils/color-theme"

const LandingPageVariantList = dynamic(() => import('./variants/list'))
const LandingPageVariantSlider = dynamic(() => import('./variants/slider'))

type Props = {
  groupList: LandingPageGroupList
  className?: string
  sliderType?: SliderType
}

const LandingPageSingleList = ({ groupList, className, sliderType }: Props) => {
  const { responsive } = useLayout()
  const { translate } = useTranslations()

  const { attributes, productReferences } = groupList ?? {}
  const { colorTheme = 'gray', displayName = '', productListingType } = attributes ?? {}

  const shouldTakeFullWidth = productReferences?.length === 1 || responsive.breakpoints.max.LG
  const fullWidth = shouldTakeFullWidth || (responsive.windowSize.width > 1600)

  const renderVariant = () => {
    switch (productListingType) {
      case ListingType.List:
        return (
          <LandingPageVariantList
            productReferences={productReferences}
            digitalDataOrigin={getDigitalDataOrigin(displayName)} />
        )
      case ListingType.Slider:
        return (
          <LandingPageVariantSlider
            groupList={groupList}
            digitalDataOrigin={getDigitalDataOrigin(displayName)}
            fullWidth={fullWidth}
            sliderType={sliderType} />
        )
      default:
        // eslint-disable-next-line no-console
        console.warn('Unknown Landing Page productListingType', productListingType)
        return
    }
  }

  return (
    <div
      className={classNames(className, {
        'col-12': !className,
      })}>
      <h2 className={`u-mb-16 h2 d-flex ${getColorThemeClass(colorTheme)}`}>
        <span className={'u-mr-8'}>{translate(displayName)}</span>
      </h2>
      <>{renderVariant()}</>
    </div>
  )
}

export default LandingPageSingleList
